import { api } from './client';
import type { UserBriefDto } from './types';

/** Сторисы (истории) — медиа на 24 часа (см. StoryService). */
export interface StoryDto {
  id: string;
  mediaFileId: string;
  mimeType?: string | null;
  caption?: string | null;
  createdAt: string;
  isMine: boolean;
  /** Просмотрена ли ЭТИМ пользователем (см. StoryService.markViewed) — раньше жило в
   *  localStorage клиента, не синхронизировалось между устройствами. */
  viewed: boolean;
}

export interface StoryAuthorDto {
  user: UserBriefDto;
  stories: StoryDto[];
  /** Замьючен ли этот автор ЭТИМ пользователем (см. StoryService.setAuthorMuted). */
  muted: boolean;
}

export function storyFeed(): Promise<StoryAuthorDto[]> {
  return api('/api/v1/stories/feed');
}

export function publishStory(mediaFileId: string, caption?: string): Promise<StoryDto> {
  return api('/api/v1/stories', { method: 'POST', body: JSON.stringify({ mediaFileId, caption: caption || undefined }) });
}

/** Публикация видео-сторис с автонарезкой на сервере, если запись длиннее настроенной
 *  длительности показа видео-сторис (см. отчёт пользователя "дать возможность размещать
 *  видео более длительного размера, но при этом делить на сторисы установленной длины") —
 *  короткое видео вернётся как одна сторис, длинное — как несколько подряд. */
export function publishStoryVideo(mediaFileId: string, caption?: string): Promise<StoryDto[]> {
  return api('/api/v1/stories/video', { method: 'POST', body: JSON.stringify({ mediaFileId, caption: caption || undefined }) });
}

export function deleteStory(id: string) {
  return api(`/api/v1/stories/${id}`, { method: 'DELETE' });
}

/** Отметить сторис просмотренной — идемпотентно, сервер не дублирует запись при повторном
 *  вызове. */
export function markStoryViewed(id: string) {
  return api(`/api/v1/stories/${id}/view`, { method: 'POST' });
}

/** Замьютить/размьютить автора сторис у себя (см. StoryViewer "Не показывать сторис..."). */
export function setStoryAuthorMuted(authorId: string, muted: boolean) {
  return api(`/api/v1/stories/authors/${authorId}/muted`, { method: 'PUT', body: JSON.stringify({ muted }) });
}
